import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ClassName, SharedConstants, SharedCSSPropertyName } from '@app/eds';

export type selectKeyValueType = {
  name: string;
  value: string;
};

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  // It is a Input() field which tells whether a field is required or not
  @Input() isRequired = false;

  // FormControl field for the select
  @Input() set control(value: FormControl) {
    if (value !== this.dataControl) {
      this.dataControl = value;
    }
  }

  // Set select state
  @Input() isDisabled = false;

  // Boolean to specify if the select dropdown is a filter dropdown.
  // Will be used for displaying the UI of the select component accordingly.
  @Input() isFilterSelect = false;

  // Placeholder for the select component
  @Input() placeholder!: string;

  // Whether the select component is transparent or not
  @Input() isTransparentSelect = false;

  // form control
  dataControl = new FormControl(SharedConstants.EMPTY_STRING, Validators.required);

  // It will contain the selected value on selecting from the options
  selectedValue: string = SharedConstants.EMPTY_STRING;

  //This dataset will be used as options in select and it should be passed as [{ value: 'steak-0', name: 'Steak' }]
  @Input() data: selectKeyValueType[] = [];

  // Provides the height for select
  @Input() height!: string;

  //Event emiiter when a dropdown value is selected
  @Output() selectionChangeHandler: EventEmitter<string> = new EventEmitter<string>();

  // default value  of dropdown
  @Input() defaultValue!: selectKeyValueType | null;

  // to show red line if custom error present
  @Input() hasCustomError = false;

  // custom error msg should be a translated string
  @Input() customErrorMsg!: string;

  // provides the width for select
  @Input() width!: string;

  // Set select icon
  @Input() showIcon = false;

  // If true then do not show any bottom border
  @Input() selectNoBorder = false;

  // If true then show a thinner bottom border
  @Input() isThinBorder = false;

  // Single select text class
  @Input() singleSelectTextClass: string = ClassName.SelectText;

  // To select the panel class
  @Input() singleSelectPanelClass: string = SharedConstants.EMPTY_STRING;

  // custom class for mat select
  @Input() public customMatSelectTextClass: string = SharedConstants.EMPTY_STRING;

  ngOnInit() {
    if (this.defaultValue) {
      this.dataControl.setValue(this.defaultValue.value);
      this.selectedValue = this.defaultValue.value;
    }
  }

  /**
   * This method will call on selecting the value from dropdown
   * It will set the selected value
   */
  onChangeValue = () => (this.selectedValue = this.dataControl.value as string);

  /*
    When new dropdown value is selected emit happens with the keyname passed as value
  */
  onSelectionChange = (option: selectKeyValueType) => {
    this.selectedValue = option.value;
    this.selectionChangeHandler.emit(option.name);
  };

  /**
   * This method will help to return styles for button.
   *
   * @returns object
   */
  getStyle = () => {
    const styleObject: { [key: string]: string } = {};

    this.height && (styleObject[SharedCSSPropertyName.HEIGHT] = this.height);

    this.width && (styleObject[SharedCSSPropertyName.WIDTH] = this.width);

    return styleObject;
  };
}
